import React from "react";
import { AS_OF_NOTE } from "../data/stats";
import "./AsOfNote.scss";

/**
 * The small print under a group of figures, saying when they were counted.
 *
 * A number with no date attached quietly ages into a false claim, so every
 * stat group on the site carries one of these. It takes its colour from
 * whatever it sits on, so the same component works on a white section and on
 * the blue hero without a variant.
 *
 * `text` overrides the site-wide line for figures that came from somewhere
 * else and were counted on their own date — a quoted third-party report, say.
 */
export default function AsOfNote({ text, className = "" }) {
  return (
    <p className={`asof${className ? ` ${className}` : ""}`}>
      <span aria-hidden="true">*</span>
      {text || AS_OF_NOTE}
    </p>
  );
}
